import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const sectionParallax = () => {
	gsap.registerPlugin(ScrollTrigger);

	// Convert NodeList to an array and iterate over each section
	gsap.utils.toArray(".large-section-intro").forEach((section) => {
		gsap
			.timeline({
				scrollTrigger: {
					trigger: section, // Individual section as the trigger
					start: "top center+=200px ", // Customize start point
					end: "bottom top", // Optional end point
					scrub: true, // Smooth scrubbing effect
				},
			})
			.to(section, {
				x: "-30%", // Parallax effect
				duration: 1, // Optional duration for smoother effect
			});
	});
};

export default sectionParallax;